module.exports = __webpack_public_path__ + "img/logo_lorni_white.0d59fb9a.svg";